import React from 'react';

class DropDownIcon extends React.Component {
  render() {
    return (
      <i className={`fas fa-chevron-${this.props.toggle ? 'up' : 'down'}`}
         style={{cursor: "pointer"}}
         onClick={this.props.onClick}
      />
    );
  }
}

export default DropDownIcon;
